module.exports = __webpack_public_path__ + "img/product-6.baba75ad.jpg";